var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3084 1.79169L17.8084 4.79167C18.1 4.90834 18.3334 5.25833 18.3334 5.56666V8.33334C18.3334 8.79167 17.9584 9.16667 17.5 9.16667H2.50002C2.04169 9.16667 1.66669 8.79167 1.66669 8.33334V5.56666C1.66669 5.25833 1.90002 4.90834 2.19169 4.79167L9.69169 1.79169C9.85836 1.72502 10.1417 1.72502 10.3084 1.79169Z",
    stroke: "#FF1C26",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 18.3333H1.66669V15.8333C1.66669 15.375 2.04169 15 2.50002 15H17.5C17.9584 15 18.3334 15.375 18.3334 15.8333V18.3333Z",
    stroke: "#FF1C26",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 15V9.16667",
    stroke: "#FF1C26",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 15V9.16667",
    stroke: "#FF1C26",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15V9.16667",
    stroke: "#F3000B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 15V9.16667",
    stroke: "#F3000B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 15V9.16667",
    stroke: "#F3000B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833313 18.3333H19.1666",
    stroke: "#F3000B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.08333C10.6904 7.08333 11.25 6.52369 11.25 5.83333C11.25 5.14298 10.6904 4.58333 10 4.58333C9.30964 4.58333 8.75 5.14298 8.75 5.83333C8.75 6.52369 9.30964 7.08333 10 7.08333Z",
    stroke: "#F3000B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.f077b3f9f4294fa24af853f744ec3f47.svg";
export { ForwardRef as ReactComponent };